import React, { useState } from "react";
import {Form, FormControl} from "react-bootstrap";

export const CustomDropdown = React.forwardRef(
    ({ children, style, className, "aria-labelledby": labeledBy }, ref) => {
        const [value, setValue] = useState("");

        return (
            <div
                ref={ref}
                style={style}
                className={className}
                aria-labelledby={labeledBy}
            >
                <FormControl
                    className="mx-3 my-2 w-auto"
                    placeholder="Type to filter..."
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                />

                <ul className="list-unstyled bordered">
                    {React.Children.toArray(children).filter(
                        (child) =>
                            !value || child.props.children.toLowerCase().startsWith(value)
                    )}
                </ul>
            </div>
        );
    }
);

export const CustomDropdown1 = ({register,label,defaultValue,options,placeholder,name,isLoading}) => {
    return <>
        <label className="salary-labels">
            {label}
        </label>
        <Form.Group>
            {
                !isLoading &&
                <Form.Control
                    as="select"
                    className="form_select_primary"
                    name={name}
                    ref={register}
                    defaultValue={defaultValue}
                >
                    <option value="">{placeholder ?? `Select ${label}`}</option>
                    {options.map(
                        (option) =>
                            <option key={option.key} value={option.key}>
                                {option.value}
                            </option>
                    )
                    }
                </Form.Control>

            }
        </Form.Group>
    </>

}